<template>
  <div>
    <FormulateInput
      v-if="personalizedType !== 'clipartCategory'"
      :name="layer.id"
      :label="label"
      :width="width"
      :height="height"
      :rotation="rotation"
      :layer='layer'
      :x="x"
      :y="y"
      type="imageremovebackground"
      :aspectRatio="aspectRatio"
    />
  </div>
</template>

<script>
import {get} from "lodash";
export default {
  name: 'ImageRemoveBackgroundField',
  props: {
    layer: {
      type: Object,
      required: true
    },
    artwork: {
      type: Object,
      required: true
    },
    personalized: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    personalizedType() {
      return this.layer.personalized.type
    },
    required() {
      return get(this.layer, 'personalized.required', false)
    },
    initialValue() {
      const { personalized, layer } = this
      return get(personalized, layer.id)
    },
    label() {
      return get(this.layer, 'personalized.label', this.layer.title)
    },
    width(){
      return get(this.layer, 'width', 1000);
    },
    height(){
      return get(this.layer, 'height', 1000);
    },
    rotation(){
      return get(this.layer, 'rotation', 1);
    },
    x(){
      return get(this.layer, 'x', 1);
    },
    y(){
      return get(this.layer, 'y', 1)
    },
    aspectRatio() {
      const { layer } = this
      return layer.width / layer.height;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Form/ImageRemoveBackgroundField.vue